/* eslint-disable */
// Generated by gulp svg-icon - do not modify manually
import React, { PureComponent as Component } from 'react';
import PropTypes from 'prop-types';
import Base from "./compose";
import { getStyle } from "./optionCallback";
import filterObject from "@gqlapp/utils/filterObject";


type Props = {
	drawIcon?: any,
	className?: string | any,
	color?: string,
	height?: number | string,
	width?: number | string,
	kind?: string,
	onClick?: any,
	preview?: boolean,
	size?: number,
	style?: any,
	wrapperStyle: any
}

class Frames extends Component<Props> {
	
	static propTypes = {
		drawIcon: PropTypes.any,
		className: PropTypes.string,
		color: PropTypes.string,
		height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
		width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
		kind: PropTypes.string.isRequired,
		onClick: PropTypes.func,
		preview: PropTypes.bool,
		size: PropTypes.number,
		style: PropTypes.oneOfType([
			PropTypes.array,
			PropTypes.object,
			PropTypes.any
		]),
		wrapperStyle: PropTypes.oneOfType([
			PropTypes.array,
			PropTypes.object
		])
	}
	
	static defaultProps = {
		opacity: 1,
		scale: 1,
		width: '100%',
		height: '100%'
	}
	
	render() {
		
		// @ts-ignore
		let kind = this.props?.kind || 'default', frames = this.props?.frames;
		
		let propKeys: string[] = 'children, backgroundColor, opacity, style'.split(',');
		propKeys = propKeys.concat('scale, color, font, text_1, text_2'.split(','))
		propKeys = propKeys.concat('frameBody, viewBox, transform, shadowDark, shadowDarker'.split(','))
		
		propKeys = propKeys.map(value => `${value}`.trim());
		try{
			let _props = {...this.props};
			// @ts-ignore
			Object.assign(_props, { text: _props?.text || '' });
			let props = filterObject(_props, function ({}, key: any){
				return propKeys.includes(key)
			})
			
			let svgProps = filterObject(_props, function ({}, key: any){
				return !(propKeys.includes(key) || ['drawIcon', 'children', 'frames', 'kind'].includes(key))
			})

			let dataStyle: any;


			if((dataStyle = getStyle(frames, kind))){
				return func(dataStyle?.callback)(Object.assign(props, { svgProps }))
			}
		}catch (e) {
			debug(e);
		}
		
		return <></>
	}
	
}


// @ts-ignore
export default function Frame(props: Props){
	const Frame = Base(Frames);
	// @ts-ignore
	return <Frame {...props} />
}
